export default function canUseFloatOpacityTexture(openGLRenderWindow, context) {
    const supportsFloatTextures = openGLRenderWindow.getWebgl2() ||
        Boolean(context.getExtension('OES_texture_float'));
    const supportsFloatLinearFiltering = Boolean(context.getExtension('OES_texture_float_linear'));
    return supportsFloatTextures && supportsFloatLinearFiltering;
}
